// Formato de fecha/hora. Usa la zona horaria elegida en Preferencias (o la del dispositivo
// si está vacía). setTz() la actualiza; las funciones leen ese valor vía Intl.

let tzPref = ''; // IANA timezone; '' = dispositivo
export function setTz(tz: string): void {
  tzPref = tz;
}

function parts(iso: string | null, opts: Intl.DateTimeFormatOptions): Record<string, string> | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const dtf = new Intl.DateTimeFormat('es-AR', { ...opts, timeZone: tzPref || undefined, hour12: false });
  const o: Record<string, string> = {};
  for (const p of dtf.formatToParts(d)) o[p.type] = p.value;
  return o;
}

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
const clean = (s: string) => s.replace('.', '');

// "16:00"
export function formatTime(iso: string | null): string {
  const p = parts(iso, { hour: '2-digit', minute: '2-digit' });
  return p ? `${p.hour}:${p.minute}` : '--:--';
}

// "Jue 11 jun · 16:00"
export function formatKickoff(iso: string | null): string {
  const p = parts(iso, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  if (!p) return 'A definir';
  return `${cap(clean(p.weekday))} ${p.day} ${clean(p.month)} · ${p.hour}:${p.minute}`;
}

// "Jueves 11 de junio"
export function formatDateLong(iso: string | null): string {
  const p = parts(iso, { weekday: 'long', day: 'numeric', month: 'long' });
  if (!p) return 'Fecha a definir';
  return cap(`${p.weekday} ${p.day} de ${p.month}`);
}

export function weekdayShort(iso: string | null): string {
  const p = parts(iso, { weekday: 'short' });
  return p ? cap(clean(p.weekday)) : '';
}
export function dayNum(iso: string | null): string {
  const p = parts(iso, { day: 'numeric' });
  return p ? p.day : '–';
}
export function monthShort(iso: string | null): string {
  const p = parts(iso, { month: 'short' });
  return p ? clean(p.month) : '';
}

// Clave de día (YYYY-MM-DD) en la zona elegida, para agrupar el calendario.
export function dayKey(iso: string | null): string {
  const p = parts(iso, { year: 'numeric', month: '2-digit', day: '2-digit' });
  return p ? `${p.year}-${p.month}-${p.day}` : 'tbd';
}

// Cuenta regresiva detallada (independiente de zona): "2d 05h 12m".
export function countdownLong(iso: string | null): string {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return '¡Comienza!';
  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (d > 0) return `${d}d ${pad(h)}h ${pad(m)}m`;
  if (h > 0) return `${pad(h)}h ${pad(m)}m ${pad(sec)}s`;
  return `${pad(m)}m ${pad(sec)}s`;
}

// Cuenta regresiva corta: "en 2 d", "en 3 h", "en 12 min", "¡ya!".
export function countdown(iso: string | null): string {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return '¡ya!';
  const min = Math.round(diff / 60000);
  if (min < 60) return `en ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `en ${h} h`;
  return `en ${Math.round(h / 24)} d`;
}
